export const NAME = 'profile'
export const PARENT_TAB = 'profileParent'
export const EMPLOYEE_TAB = 'profileEmployee'



// WEBPACK FOOTER //
// ../source/views/Profile/constants.js